import { CommentType, CommentTypeName } from '~/typings/entities/Ticket';

// Reclame Aqui service channel. Tickets on this channel use the extended resolution flow
// (WhatsApp + public + reserved messages); every other channel keeps the single-message flow.
export const RECLAME_AQUI_CHANNEL_ID = 29;

export const COMMENT_TYPE: Record<'WHATSAPP' | 'PUBLIC' | 'PRIVATE' | 'BACKOFFICE', CommentTypeName> = {
  WHATSAPP: 'WHATSAPP',
  PUBLIC: 'PUBLIC_RA',
  PRIVATE: 'PRIVATE_RA',
  BACKOFFICE: 'BACKOFFICE',
};

export const PUBLIC_MESSAGE_MAX_LENGTH = 1000;
export const RESERVED_MESSAGE_MAX_LENGTH = 1000;
export const WHATSAPP_COMMENT_MAX_LENGTH = 700;

export function isReclameAquiChannel(serviceChannelId?: number | null): boolean {
  return serviceChannelId === RECLAME_AQUI_CHANNEL_ID;
}

// Resolves the numeric id of a comment type from the list returned by GET /ticket/comment-types.
export function findCommentTypeId(types: CommentType[] | undefined, name: CommentTypeName): number | undefined {
  return types?.find((type) => type?.name?.toUpperCase() === name)?.id;
}

export const RA_STEPS = ['Dados', 'WhatsApp', 'Reclame Aqui', 'Revisão'] as const;

// Steps for the standard (non Reclame Aqui) resolution flow: no public/reserved messages,
// just the WhatsApp response and the final review.
export const STANDARD_STEPS = ['Dados', 'WhatsApp', 'Revisão'] as const;
